import Vue from 'vue'
import Vuex from 'vuex'

//需要使用插件一次
Vue.use(Vuex)


const state = {
    count:0
}  // 仓库存储数据的地方

const mutations = {
    increment (state, payload) {
        console.log(232323,state.count,payload);
        state.count=state.count-1
        // state表示store中所有数据
        // payload表示组件中传递过来的数据
		// state.age = state.age + payload
    },
    Assign(state, payload){
        state.count=payload
    }
}  // 修改state的唯一手段
const actions = {
}  // 处理actions，可以书写自己的业务逻辑，也可以处理异步
const getters = {}  // 理解为计算属性，用于简化仓库数据，让组件获取仓库的数据更加方便

//对外暴露Store类的一个实例
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})



// WEBPACK FOOTER //
// ./src/store/index.js